import { ZoningCode } from 'src/app/modules/instance/models';
import { ReplaySubject } from 'rxjs';
import { ZoningCodeService } from './../../services/zoning-code.service';
import { SynchronizationEventService } from '../../../synchronization/services/synchronization-event.service';
import { Task } from '../../../../shared/models/task';
import { switchMap, takeUntil } from 'rxjs/operators';
import { TaskService } from '../../services/task.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import ITask = ZoningAPI.ITask;
import IZoningCodeIdentity = ZoningAPI.IZoningCodeIdentity;
import { SEARCHABLE_JOBS_LIST } from '../../constants';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import * as _ from 'lodash';
import { TaskCalcProcessDetailViewComponent } from './task-process-detail-view/task-process-detail-view.component';

@Component({
    standalone: false,
    selector: 'app-task-details-view-tab',
    templateUrl: './process-details-view-tab.component.html',
    styleUrls: ['./process-details-view-tab.component.scss']
})
export class ProcessDetailsViewTabComponent implements OnInit, OnDestroy {
    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

    @ViewChild(TaskCalcProcessDetailViewComponent) taskComponent: TaskCalcProcessDetailViewComponent;

    task: ITaskModel;
    zoningCode: ZoningCode;
    taskId: string;
    isJobProcess: boolean;
    showSpinner: boolean;
    isZoningCodeLoading: boolean;

    constructor(
        private readonly taskService: TaskService,
        private activateRoute: ActivatedRoute,
        private readonly sync: SynchronizationEventService,
        private readonly zoningCodeService: ZoningCodeService
    ) {}

    ngOnInit(): void {
        this.showSpinner = true;
        this.isZoningCodeLoading = true;
        this.activateRoute.queryParamMap
            .pipe(
                switchMap((queryParam: ParamMap) => {
                    const state: string = queryParam.get('state_env');
                    return this.activateRoute.paramMap.pipe(
                        switchMap(params => {
                            this.taskId = params.get('id');
                            return this.taskService.getTaskByIdAndState({
                                id: this.taskId,
                                state
                            });
                        })
                    );
                })
            )
            .subscribe(task => {
                if (!task.type) {
                    this.task = null;
                    this.showSpinner = false;
                    return;
                }
                this.task = task;
                this.showSpinner = false;
                this.isJobProcess = SEARCHABLE_JOBS_LIST.includes(this.task.type);
                this.zoningCodeService
                    .getZoningCodesByIds([this.getCurrentZoningCodeToLoad()])
                    .subscribe(zoningCodes => {
                        this.zoningCode = zoningCodes[0];
                        this.isZoningCodeLoading = false;
                    });
            });
        this.sync.updatedProcessesSubject.pipe(takeUntil(this.destroyed$)).subscribe(tasks => {
            if (_.isEmpty(tasks)) {
                return;
            }
            const currentTask: ITask = tasks.find(task => this.taskId === task.id);
            if (currentTask) {
                if (!this.task) {
                    this.task = new Task(currentTask);
                    return;
                }
                this.task.initWithJSON(currentTask);
                if (this.taskComponent) {
                    this.taskComponent.prepareTaskData();
                }
            }
        });
    }

    private getCurrentZoningCodeToLoad(): IZoningCodeIdentity {
        return { Id: this.task.zoningCodeId, State: this.task.state };
    }

    ngOnDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
